import BaseEntityService from 'vue-core/services/BaseEntityService';
import env from 'environment';

class AnalysisTypeService
    extends BaseEntityService {
  constructor() {
    super({
      baseUrl: env.baseUrl + '/analysis-types'
    });
  }
}

const service = new AnalysisTypeService();

export default service;
